import React from "react";
import { useTranslation } from "react-i18next";
import { getServicesArray } from "../../../utils/utility";

function Services({themeData, isExt, theme, selectedTheme, services}) {
  const { t } = useTranslation();

  const styles = {
    serviceBoxStyle: {
        background: themeData?.dynamicBackgroundColor ||  selectedTheme?.bgColor || "",
        padding: selectedTheme?.padding,
        margin: selectedTheme?.margin,
    },
    serviceHeadingStyle: {
        color: themeData?.dynamicTextDescriptionColor || selectedTheme?.textColor || "" ,
        // margin: '0 0 15px 0',
        // textAlign: selectedTheme?.headingAlign
    },
    serviceOpenHeadingStyle: {
        color: theme == "temp35" ? themeData?.dynamicTextDescriptionColor : themeData?.dynamicTextHeadingColor || (theme === "temp29" ? "#9EAFB7" : "")
        // margin: '0 0 15px 0',
        // textAlign: selectedTheme?.headingAlign
    },
    listStyle: {
        border: theme == "temp11" ?  `1px solid ${themeData?.dynamicCtaColor}` :  theme == "temp4" || theme == "temp16" || theme == "temp36" ? `1px solid ${themeData?.dynamicTextHeadingColor}` :  theme ==  "temp3" || theme ==  "temp6" || theme ==  "temp18" || theme ==  "temp28" || theme ==  "temp29" || theme ==  "temp32" || theme ==  "temp33" || theme ==  "temp34" ? "" : `1px solid ${themeData?.dynamicTextDescriptionColor}`,
        color: theme == "temp35" || theme == "temp36" ? `${themeData?.dynamicTextHeadingColor}` : theme == "temp29" ? `${themeData?.dynamicTextHeadingColor}B3` || "#000" : theme == "temp4" || theme == "temp5" || theme == "temp11" || theme == "temp16" || theme == "temp30" ? themeData?.dynamicTextDescriptionColor :  theme ==  "temp3" || theme ==  "temp28" || theme ==  "temp34" ? `${themeData?.dynamicTextDescriptionColor}90` : `${themeData?.dynamicTextDescriptionColor}B3` || "",
        background : theme == "temp35" ? themeData?.dynamicMainBackgroundColor : theme == "temp4" || theme == "temp16" || theme == "temp27" ? themeData?.dynamicBackgroundColor : "",
        boxShadow : theme == "temp4" ? `0px 0px 10px 0px ${themeData?.dynamicTextHeadingColor}B3` : "",
        borderColor: theme == "temp30" ? themeData?.dynamicTextDescriptionColor : ""
    }
};
console.log("services11",selectedTheme)
let mainStyleCondition = selectedTheme?.servicesType == "open" ? {} : selectedTheme?.servicesType == "box" ? styles.serviceBoxStyle : {}
let headingStyleCondition  = selectedTheme?.servicesType == "open" ? styles.serviceOpenHeadingStyle  :  selectedTheme?.servicesType == "box" ? styles.serviceHeadingStyle : {}
let headingStyleClassName = theme == "temp3" ||  theme == "temp6" ||  theme == "temp16" ||  theme == "temp29" ? "service" : ""
let ULStyleClassName = theme == "temp3" || theme == "temp18" || theme == "temp28" ? "servesbox-mt" : ""
  return (
    <>
      <article className="servicesName sec" style={mainStyleCondition}>
        <h3 class={`sectitle ${headingStyleClassName}`} style={headingStyleCondition}>{themeData?.headingsObj?.service_Heading || t("Services")} </h3>
        <div className="mainservicebox">
          {services?.length > 0  && (
            <ul className={`servesbox ${ULStyleClassName}`}>
              {services.map((val, index) => (
                val?.name && (
                  <li key={index} className="service-list" style={styles.listStyle}>
                    {val.name}
                  </li>
                )
              ))}
            </ul>
          )}
        </div>
      </article>
    </>
  );
}
export default Services;
